
import React, { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";

const CreateStockVariantProfit = () => {
  const [name, setName] = useState("");
  const [profit, setProfit] = useState("");
  const [profit_type, setProfitType] = useState("");
  const [stock_id, setStockId] = useState("");
  const [stock_variant_id, setStockVariantId] = useState("");
  const [loading, setLoading] = useState(false);


  const navigate = useNavigate();
  const location = useLocation();
  const productStock = location.state?.productStock;

  useEffect(() => {
    if (productStock) {
      // console.log("productStock", productStock);
      setName(productStock.name || "");
      setStockId(productStock.stock_id || "");
      setStockVariantId(productStock.variant_id || "");
      setProfit(productStock.discount_percentage || "");
      setProfitType(productStock.profit_type || "percentage");
    }
  }, [productStock]);

  const validateForm = () => {
    if (!name || !profit_type) {
      toast.error("Profit type is required.");
      return false;
    }

    if (!profit || parseFloat(profit) <= 0) {
      toast.error("Profit value must be greater than 0.");
      return false;
    }

    return true;
  };

  //axios api encryption call
  const axios = AxiosApiCall();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    const formData = {
      stock_id,
      stock_variant_id,
      profit,
      profit_type,
    }
    // console.log("formData", formData);


    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const response = await axios.put(
        ApiServices.updateProductStockVariantProfit,
        formData,
        // { stock_id, profit, profit_type },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "profit-stock-supply-added-success" });

        navigate("/admin/product/stock/details", {
          state: { stock_id: productStock.stock_id }
        });
        setProfit("");
        setProfitType("");

      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className=" body-font">
            <div className="container px-5 pb-2 mx-auto ">
              <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                  <ol className="list-none p-0 inline-flex mb-2">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Product Stock Variant
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Profit
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-orange1">update</p>
                    </li>
                  </ol>
                </nav>
              </section>
              <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <input type="hidden" name="stock_id" value={stock_id} />
                    <input type="hidden" name="stock_variant_id" value={stock_variant_id} />
                    <div className="w-full">
                      <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Stock Name
                      </label>
                      <div className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                        {name}
                      </div>
                    </div>
                    <div className="w-full">
                      <label
                        htmlFor="status"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Profit Type
                      </label>
                      <select
                        id="profit_type"
                        value={profit_type}
                        onChange={(e) => setProfitType(e.target.value)}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      >
                        <option value="" disabled>
                          Select profit type
                        </option>
                        <option value="amount">Amount</option>
                        <option value="percentage">Percentage</option>
                      </select>
                    </div>

                    {profit_type && (
                      <div className="w-full col-span-2">
                        <label htmlFor="profit" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                          {profit_type === "amount" ? "Amount" : "Percentage amount (%)"}
                          {profit_type === "amount" && <span className="px-3 text-gray-700 text-sm">₦</span>}
                        </label>
                        <input
                          type="number"
                          name="profit"
                          id="profit"
                          value={profit}
                          onChange={(e) => setProfit(e.target.value)}
                          className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                          placeholder={profit_type === "amount" ? "Enter fixed amount" : "Enter percentage discount"}
                        />
                      </div>
                    )}

                  </div>

                  <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                    <Link
                      to="/admin/product/stock/details"
                      state={{ stock_id: productStock.stock_id }}
                      className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
                    >
                      <List className="mr-2" />
                      Back To List
                    </Link>
                    <button
                      type="submit"
                      className={`text-white bg-darkGreen3 text-dGrey3  capitalize border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"}`}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : `Add ${profit_type || 'Discount'} To Product Stock Variant`}

                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </MainLayouts>
    </div>
  );
};

export default CreateStockVariantProfit;

